
import React, { useState } from 'react';
import img1 from '../assets/Galeria1.jpg';
import img2 from '../assets/Galeria2.jpg';
import img3 from '../assets/Galeria3.jpg';
import img4 from '../assets/Galeria4.jpg';
import img5 from '../assets/Galeria5.jpg';
import img6 from '../assets/Galeria6.jpg';
import img7 from '../assets/Galeria7.jpg';
import img8 from '../assets/Galeria8.jpg';
import img9 from '../assets/Galeria9.jpg';
import img10 from '../assets/Galeria10.jpg';
import img11 from '../assets/Galeria11.jpg';
import img12 from '../assets/Galeria12.jpg';

const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12];

export default function Galeria() {
  const [selectedImg, setSelectedImg] = useState(null);

  const openModal = (img) => setSelectedImg(img);
  const closeModal = () => setSelectedImg(null);

  return (
    <section id="galeria" className="bg-[#f28c281a] min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-semibold mb-8 text-[#0033A0] text-center">Galería</h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {images.map((img, idx) => (
            <div
              key={idx}
              className="overflow-hidden rounded-xl shadow-md hover:scale-105 transition-transform duration-300 cursor-pointer"
              onClick={() => openModal(img)}
            >
              <img
                src={img}
                alt={`galeria-${idx + 1}`}
                className="w-full h-48 object-cover"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {selectedImg && (
        <div
          onClick={closeModal}
          className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center p-4"
        >
          <img
            src={selectedImg}
            alt="Zoom"
            className="max-w-full max-h-[90vh] rounded-xl border-4 border-white shadow-2xl transition-transform duration-300 scale-100 hover:scale-105"
          />
        </div>
      )}
    </section>
  );
}